import { __assign, __rest } from "tslib";
import Button from '@material-ui/core/Button';
import React from 'react';
import { BLayout } from '../BLayout';
/**
 * **Doesn't have to be a child of BForm**
 *
 * BButton doesn't have any default action. You may use for toggling or changing your own state.
 * For type 'submit' & 'reset' we recommend using BSubmit & BReset.
 *
 * To include the BButton within the layout grid of Mui-Bueno, provide a w (more information about w can be found here). Otherwise, the button will be rendered as is (`<button>`).
 *
 * **Optional Props:**
 * - name
 *  - any string accepted
 * - Type
 *  - options: 'button' | 'submit' | 'reset'
 * - color
 *  - options: 'inherit' | 'primary' | 'secondary' | 'default'
 * - variant
 *  - options: "text" | "outlined" | "contained"
 * - locationInButtonBar
 *  - should only be used when button is used in BButtonBar. Specifies the location within the BButtonBar that the button will be in. Default is 'right'.
 * - onClick
 *  - without an onClick BButton will do nothing
 * - [ButtonProps](https://material-ui.com/api/button/#props)
 *  - any Material-UI props
 * - [BLayoutProps](https://gitlab.com/2020-bootcamp/forms/mui-bueno/-/blob/development/docs/types/BLayoutProps.md)
 *  - custom gridding, sizes, and alignment
 *
 * **Basic Example:**
 * ```jsx
 * <BButton
 *   name="next"
 *   onClick(()=> { setValue(value++) })
 * >Next
 * </BButton>
 * ```
 *
 * Demos:
 *
 * - [Sample Form](http://mui-bueno.pipeline.east1.simoncomputing.com.s3-website-us-east-1.amazonaws.com/BButton)
 *
 * API:
 *
 * - [BButton API](https://gitlab.com/2020-bootcamp/forms/mui-bueno/-/blob/development/docs/tag-references/button/BButton.md)
 */
export var BButton = function (_a) {
    var buttonProps = _a.buttonProps, w = _a.w, _b = _a.name, name = _b === void 0 ? "button" : _b, _c = _a.type, type = _c === void 0 ? "button" : _c, _d = _a.color, color = _d === void 0 ? "primary" : _d, _e = _a.variant, variant = _e === void 0 ? "contained" : _e, _f = _a.locationInButtonBar, locationInButtonBar = _f === void 0 ? 'right' : _f, _g = _a.onClick, onClick = _g === void 0 ? undefined : _g, className = _a.className, props = __rest(_a, ["buttonProps", "w", "name", "type", "color", "variant", "locationInButtonBar", "onClick", "className"]);
    var button = React.createElement(Button, __assign({}, buttonProps, { name: name, color: color, variant: variant, type: type, onClick: onClick, children: props.children, fullWidth: w ? true : false, className: className }));
    return (w ?
        React.createElement(BLayout, __assign({}, props, { w: w }), button) :
        button);
};
//# sourceMappingURL=BButton.js.map